import { Link } from 'react-router-dom';
import tgChannal from '../../../assets/images/project__AU_Arena_Chimki.webp';
import { useTranslation } from 'react-i18next';
import './footer.scss'

const Footer: React.FC = () => {
    const { t } = useTranslation();
    return (
        <footer className='footer' id='footer'>
            <div className="footer__text">
                <h2 className="footer__text-h2">{t('footer.title')}</h2>
                {/* <div className="phone">
                    <h3 className="footer__text-h3">Телефон</h3>
                    <p className="footer__text-p">+7(495) 925-30-75</p>
                </div> */}
                <div className="info">
                    <h3 className="footer__text-h3">{t('footer.emailTitle')}</h3>
                    <p className="footer__text-p">info@right-systems.ru</p>
                </div>
                <div className="support">
                    <h3 className="footer__text-h3">{t('footer.supportTitle')}</h3>
                    <p className="footer__text-p">support@right-systems.ru</p>
                </div>
                {/* <div className="address">
                    <h3 className="footer__text-h3">Адрес</h3>
                    <p className="footer__text-p">105318, г. Москва, ул. Ткацкая, д. 1</p>
                </div> */}
                <div className="timeWork">
                    <h3 className="footer__text-h3">{t('footer.workTimeTitle')}</h3>
                    <p className="footer__text-p">{t('footer.workTimeWeekdays')}</p>
                    <p className="footer__text-p">{t('footer.workTimeWeekend')}</p>
                </div>
                <Link to='/policy' className="policy__link">{t('footer.privacyPolicy')}</Link>
                <div className="contact">
                    <h3 className="footer__text-h3">{t('footer.contactUs')}</h3>
                    <a href="https://t.me/RSS_Team_Bot" target="_blank" className="contact__TG">
                        <svg role="presentation" width="30px" height="30px" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M50 100c27.614 0 50-22.386 50-50S77.614 0 50 0 0 22.386 0 50s22.386 50 50 50Zm21.977-68.056c.386-4.38-4.24-2.576-4.24-2.576-3.415 1.414-6.937 2.85-10.497 4.302-11.04 4.503-22.444 9.155-32.159 13.734-5.268 1.932-2.184 3.864-2.184 3.864l8.351 2.577c3.855 1.16 5.91-.129 5.91-.129l17.988-12.238c6.424-4.38 4.882-.773 3.34.773l-13.49 12.882c-2.056 1.804-1.028 3.35-.129 4.123 2.55 2.249 8.82 6.364 11.557 8.16.712.467 1.185.778 1.292.858.642.515 4.111 2.834 6.424 2.319 2.313-.516 2.57-3.479 2.57-3.479l3.083-20.226c.462-3.511.993-6.886 1.417-9.582.4-2.546.705-4.485.767-5.362Z" fill="#ffffff"></path></svg>
                    </a>
                </div>
                <div className="tgChannal">
                    <h3 className="footer__text-h3">{t('footer.channelTitle')}</h3>
                    <a href="https://t.me/CCTVsafety" target="_blank" className="contact__TG">
                        <img src={tgChannal} alt="camera" className='tgChannal__img' />
                        <p id='tgChannal__name' className="footer__text-p">Видеобезопасность</p>
                    </a>
                </div>
            </div>

            <div className="yandex-map">
                <div style={{ position: "relative", overflow: "hidden", height: "100%" }}>
                    <a
                        href="https://yandex.ru/maps/213/moscow/?utm_medium=mapframe&utm_source=maps"
                        style={{
                            color: "#eee",
                            fontSize: "12px",
                            position: "absolute",
                            top: "0px",
                        }}
                    >
                        Москва
                    </a>
                    <a
                        href="https://yandex.ru/maps/213/moscow/house/tkatskaya_ulitsa_1/Z04YcQZoQUAAQFtvfXt5d3hhYA==/?ll=37.718926%2C55.786425&utm_medium=mapframe&utm_source=maps&z=16"
                        style={{
                            color: "#eee",
                            fontSize: "12px",
                            position: "absolute",
                            top: "14px",
                        }}
                    >
                        Ткацкая улица, 1 — Яндекс Карты
                    </a>
                    <iframe
                         src="https://yandex.ru/map-widget/v1/?ll=37.718926%2C55.786425&mode=search&z=14"
                         width="100%"
                         height="100%"
                        //  frameBorder="1"
                         allowFullScreen
                         style={{ position: "relative" }}
                         title="Yandex Map"
                    ></iframe>

                </div>
            </div>
        </footer>
    )
}

export default Footer;